import React, { Component } from 'react'
import CheckboxTree from 'react-checkbox-tree'
import 'Styles/rubricTree.scss'

export default class RubricTree extends Component {
    constructor(props) {
        super();

        let checked = [];
        this.rootRubricId = null;

        if (props.initialRubric != null) {
            this.rootRubricId = props.initialRubric;
            let rubricToSelect = this.FindNode(props.items, props.initialRubric);
            this.CheckNodeWithChildren(rubricToSelect, checked);
        }

        this.state = {
            checked: checked,
            expanded: []
        };

        this.icons = {
            expandClose: <div className="rct-icon rct-icon-expand-close"/>,
            expandOpen: <div className="rct-icon rct-icon-expand-open" />,
            check: <div className="rct-icon rct-icon-check" />,
            uncheck: <div className="rct-icon rct-icon-uncheck" />,
            halfCheck: <div className="rct-icon rct-icon-half-check" />
        }

        window.state = this;
    }

    FindNode(nodes, nodeValue) {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].value === nodeValue) {
                return nodes[i];
            }

            if (nodes[i].children != null) {
                let node = this.FindNode(nodes[i].children, nodeValue);

                if (node != null)
                    return node;
            }
        }
    }

    CheckNode(checkedNodes, target) {
        let checked = [];

        if (this.rootRubricId === target.value) {
            this.rootRubricId = null;
            this.setState({ checked: checked });
            this.props.onSelectedNodeChanged(null, '');

            return;
        }

        this.rootRubricId = target.value;

        this.CheckNodeWithChildren(target, checked);
        
        this.setState({ checked: checked });

        this.props.onSelectedNodeChanged(target.value, target.label);
    }

    CheckNodeWithChildren(node, checked) {
        if (node == null) return;

        checked.push(node.value)
        
        if (node.children == null)
            return;

        node.children.forEach(child => {
            this.CheckNodeWithChildren(child, checked);
        });
    }

    render() {
        return (
            <CheckboxTree nodes={ this.props.items }
                          checked={ this.state.checked }
                          expanded={ this.state.expanded } 
                          onCheck={ this.CheckNode.bind(this) }
                          onExpand={ expanded => this.setState({ expanded }) } 
                          icons = { this.icons } />
        )
    }
}